import { z } from "zod";

export const avtaleSchema = z.object({
  id: z.string(),
});

export type Avtale = z.infer<typeof avtaleSchema>;
